import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SubHeaderComponent } from "../../Core/sub-header/sub-header.component";
import { AuthService } from '../../../Services/auth.service';
import { NgClass, NgIf } from '@angular/common';
import { RmportalHeaderComponent } from '../rmportal/rmportal-header/rmportal-header.component';
import { KalakaarHeaderComponent } from '../kalakaar/kalakaar-header/kalakaar-header.component';
import { CustomerHeaderComponent } from '../../Admin-Dashboard/customer-header/customer-header.component';
import { CaHeaderComponent } from '../sells-panel/ca-header/ca-header.component';
import { InvoiceGstHeaderComponent } from '../sells-panel/invoice-gst-header/invoice-gst-header.component';
@Component({
  selector: 'app-authenticated-layout',
  imports: [RouterOutlet, NgIf, SubHeaderComponent, NgClass, RmportalHeaderComponent, KalakaarHeaderComponent, CustomerHeaderComponent, CaHeaderComponent, InvoiceGstHeaderComponent],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.css',
})
export class AuthenticatedLayoutComponent {
  constructor(private authService: AuthService) {}


  get role(): string | null {
    return this.authService.getUserRole();
  }
  get isKalakar() : boolean {
    return this.authService.isKalakaar();
  }

  get isCA() : boolean {
    return this.authService.isCA();
  }

  get isStaff() : any {
    return this.authService.getUserRole();
  }

   get isCustomer(): boolean {
    return this.authService.isCustomer();
  }

  get isGstStaff(): boolean {
    return this.authService.isGstStaff();
  }

  get isStaffUser(): boolean {
    return (
      this.role === 'Staff' &&
      !this.isKalakar &&
      !this.isCustomer &&
      !this.isCA &&
      !this.isGstStaff
    );
  }

  get isOwner(): boolean {
    return this.role === 'Owner';
  }
}
